define(["require", "exports", "tslib", "./DirectiveSplitText", "./DirectiveTextHeight"], function (require, exports, tslib_1, DirectiveSplitText_1, DirectiveTextHeight_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.getTextHeight = exports.splitText = exports.drawText = void 0;
    DirectiveSplitText_1 = (0, tslib_1.__importDefault)(DirectiveSplitText_1);
    DirectiveTextHeight_1 = (0, tslib_1.__importDefault)(DirectiveTextHeight_1);
    exports.splitText = DirectiveSplitText_1.default;
    exports.getTextHeight = DirectiveTextHeight_1.default;
    var defaultConfig = {
        debug: false,
        align: 'center',
        vAlign: 'middle',
        fontSize: 14,
        fontWeight: '',
        fontStyle: '',
        fontVariant: '',
        font: 'Arial',
        lineHeight: undefined,
        justify: false
    };
    function drawText(ctx, myText, inputConfig) {
        var width = inputConfig.width, height = inputConfig.height, x = inputConfig.x, y = inputConfig.y;
        var config = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, defaultConfig), inputConfig);
        if (width <= 0 || height <= 0 || config.fontSize <= 0) {
            return { height: 0 };
        }
        var xEnd = x + width;
        var yEnd = y + height;
        var fontStyle = config.fontStyle, fontVariant = config.fontVariant, fontWeight = config.fontWeight, fontSize = config.fontSize, font = config.font;
        var style = "".concat(fontStyle, " ").concat(fontVariant, " ").concat(fontWeight, " ").concat(fontSize, "px ").concat(font);
        ctx.font = style;
        var txtY = y + height / 2 + config.fontSize / 2;
        var textAnchor;
        if (config.align === 'right') {
            textAnchor = xEnd;
            ctx.textAlign = 'right';
        }
        else if (config.align === 'left') {
            textAnchor = x;
            ctx.textAlign = 'left';
        }
        else {
            textAnchor = x + width / 2;
            ctx.textAlign = 'center';
        }
        var textArray = (0, DirectiveSplitText_1.default)({
            ctx: ctx,
            text: myText,
            justify: config.justify,
            width: width
        });
        var charHeight = config.lineHeight
            ? config.lineHeight
            : (0, DirectiveTextHeight_1.default)({ ctx: ctx, text: 'M', style: style });
        var vHeight = charHeight * (textArray.length - 1);
        var negOffset = vHeight / 2;
        var debugY = y;
        if (config.vAlign === 'top') {
            ctx.textBaseline = 'top';
            txtY = y;
        }
        else if (config.vAlign === 'bottom') {
            ctx.textBaseline = 'bottom';
            txtY = yEnd - vHeight;
            debugY = yEnd;
        }
        else {
            ctx.textBaseline = 'bottom';
            debugY = y + height / 2;
            txtY -= negOffset;
        }
        textArray.forEach(function (txtlineSource) {
            var txtline = txtlineSource.trim();
            ctx.fillText(txtline, textAnchor, txtY);
            txtY += charHeight;
        });
        if (config.debug) {
            var debugColor = '#0C8CE9';
            ctx.lineWidth = 1;
            ctx.strokeStyle = debugColor;
            ctx.strokeRect(x, y, width, height);
            ctx.lineWidth = 1;
            ctx.strokeStyle = debugColor;
            ctx.beginPath();
            ctx.moveTo(textAnchor, y);
            ctx.lineTo(textAnchor, yEnd);
            ctx.stroke();
            ctx.strokeStyle = debugColor;
            ctx.beginPath();
            ctx.moveTo(x, debugY);
            ctx.lineTo(xEnd, debugY);
            ctx.stroke();
        }
        var textHeight = vHeight + charHeight;
        return { height: textHeight };
    }
    exports.drawText = drawText;
});
//# sourceMappingURL=DirectiveWaterMarkCore.js.map